import { React, useState, useEffect } from 'react'
import EventsList from "../components/Events.json";
import Event from '../components/Event'
import img from '../assets/Banners/Banner - 002_shorter.jpg'
import projects from '../components/Projects.json'
import { LinkIcon } from '../assets/icons';
import { Link } from "react-router-dom"

export default function Events() {
    //const [upcomingEventsList, setUpcomingEventsList] = useState([]);
    //const [pastEventsList, setPastEventsList] = useState([]);
    const [updates, setUpdates] = useState([]);

    useEffect(() => {
        var trafficUpdates = [];
        var tiles = [];

        projects.forEach((p) => {
            if (p.trafficUpdate !== undefined || p.trafficImg !== undefined) {
                trafficUpdates.push(p)
            }
        })

        if (trafficUpdates.length == 0) {
            tiles.push(<div className='card shadow text-center col-12 p-3' key="noTrafficUpdates">
                <h3>No Traffic Updates</h3>
            </div>)
        }

        trafficUpdates.forEach((t) => {
            tiles.push(<div className="col-4" key={t.id}>
                <div className='card shadow'>
                    <div className='card-body'>
                        <Link to={`/viewprojects/${t.id}`} style={{ textDecoration: 'none' }}>
                            <h5>Project {t.number}</h5>
                            <h4>{t.title} <LinkIcon /></h4>
                        </Link>
                        <p>{t.trafficUpdate}</p>
                        <div >
                            {t.trafficImg.map((link, index) => (
                                <a key={index} href={link} target="_blank" rel="noopener noreferrer">
                                    <img src={link} alt=''
                                        style={{ width: '100%', objectFit: 'cover', borderRadius: '4px', display: 'block', cursor: 'pointer' }} />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            )
        })
        setUpdates(tiles)

        /*
                EventsList.sort((a, b) => {
                    return new Date(a.Date) - new Date(b.Date);
                });
                var past = [], upcoming = [];
        
                var yesterdayDate = new Date();
                yesterdayDate.setDate(yesterdayDate.getDate() - 1);
        
                EventsList.forEach(e => {
                    (new Date(e.Date) > new Date(yesterdayDate)) ? upcoming.push(<Event event={e} key={e.id} />) : past.push(<Event event={e} key={e.id} />)
                });
        
                setUpcomingEventsList(upcoming);
                setPastEventsList(past);
        */
    }, [])

    /*
    FOR EVENTS.JSON:
    {
        "Title": "",
        "Date": "2019-5",
        "Body": "",
        "img": "./assets/Events/Spring-Creek-Bridge-Ribbon-Cutting-website.jpg",
        "id": 1
    }

    */
    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover" }}
                        alt=''
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                Traffic Updates
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="container py-4">
                    <div className='row align-items-start'>
                        {updates}
                    </div>

                    {/*               
                    <h1>Upcoming Events</h1>
                    {(upcomingEventsList.length === 0) ? <h3 className="text-center text-secondary py-2"><em>No Upcoming Events</em></h3> : upcomingEventsList}
                    <hr />
                     <h1>Past Events</h1>
                    {(pastEventsList.length === 0) ? <h3 className="text-center text-secondary"><em>No Past Events</em></h3> : pastEventsList} 
                    */}

                </div>
            </main>
        </div>
    )
}